import type { RouteLocationNormalized } from 'vue-router';
import { useModalStore } from '@shared/model';
import { useCartStore } from '@entities/order';
import { modalStateEnum } from '~/utils/enums/modalStateEnum';
import { defineNuxtRouteMiddleware } from '#app';

/**
 *
 */
export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {

  const storeModal = useModalStore();
  const cartStore = useCartStore();

  // Проверяем, был ли редирект с хэшем (т.е. успешная авторизация через Яндекс)
  if (to.redirectedFrom && to.redirectedFrom.hash) {
    const hash: string = to.redirectedFrom.hash; // Хэш из исходного маршрута
    /**
     * Разбираем hash и извлекаем access_token.
     * Пример hash: `#access_token=your_token&token_type=bearer&expires_in=3600`
     */
    const params = new URLSearchParams(hash.slice(1));

    const yookassaConfirmed: string | null = params.get('yookassa');

    // // Если токен найден и код выполняется на клиенте, отправляем его на бэкенд
    if (yookassaConfirmed && process.client) {
      storeModal.open(modalStateEnum.ModalThankYou)
      cartStore.closeBasket();
    }
  }
});